import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Auth/Login';
import Home from './components/Home/Home';
import Profile from './components/Profile/Profile';
import ProjectView from './components/Project/ProjectView';
import FailedGenerations from './components/FailedGenerations/FailedGenerations';
import PromptLibrary from './components/PromptLibrary/PromptLibrary';
import Downscaler from './components/Downscaler/Downscaler';
import Sidebar from './components/Sidebar/Sidebar';
import OnlineUsers from './components/OnlineUsers/OnlineUsers';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return user ? children : <Navigate to="/login" />;
};

const Layout = ({ children }) => {
  const [selectedProjectId, setSelectedProjectId] = useState(null);

  return (
    <div className="app-layout">
      <Sidebar
        selectedProjectId={selectedProjectId}
        onSelectProject={setSelectedProjectId}
      />
      <div className="main-content">{children}</div>
      <OnlineUsers />
    </div>
  );
};

function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout>
                <Home />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/my-generations"
          element={
            <PrivateRoute>
              <Layout>
                <Home />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/prompt-library"
          element={
            <PrivateRoute>
              <Layout>
                <PromptLibrary />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/downscaler"
          element={
            <PrivateRoute>
              <Layout>
                <Downscaler />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Layout>
                <Profile />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/failed"
          element={
            <PrivateRoute>
              <Layout>
                <FailedGenerations />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/project/:projectId"
          element={
            <PrivateRoute>
              <Layout>
                <ProjectView />
              </Layout>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
